import { useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost/ehaazri/api';

const DynamicFavicon = () => {
  useEffect(() => {
    const updateFavicon = async () => {
      try {
        const response = await axios.get(`${API_URL}/landing_page_api.php`);
        if (response.data.status === 'success') {
          const config = response.data.data.config || {};

          if (config.site_favicon) {
            // Convert relative path to absolute URL
            const faviconPath = config.site_favicon.startsWith('http')
              ? config.site_favicon
              : `${API_URL.replace('/api', '')}/${config.site_favicon}`;

            // Update favicon
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.head.appendChild(link);
            }
            link.href = faviconPath;

            // Update apple-touch-icon
            let appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
            if (!appleTouchIcon) {
              appleTouchIcon = document.createElement('link');
              appleTouchIcon.rel = 'apple-touch-icon';
              document.head.appendChild(appleTouchIcon);
            }
            appleTouchIcon.href = faviconPath;
          }

          // Update page title if configured
          if (config.site_logo_alt) {
            document.title = config.site_logo_alt;
          }
        }
      } catch (error) {
        console.error('Failed to fetch favicon:', error);
      }
    };

    updateFavicon();
  }, []);

  return null; // This component doesn't render anything
};

export default DynamicFavicon;
